import React from "react"

import { useDispatch } from "react-redux"

import { Card, Row, Col, Button } from "react-bootstrap"

import { toggleValuationModal } from "@/slices/valuationModalSlice"

function HomeToSell() {
    const dispatch = useDispatch()

    return (
        // Home To Sell Card
        <Col xs={12} as={Card} className="sticky-top-scroll-2 mt-5 ">
            <Row as={Card.Body} className="m-0 justify-content-center">
                <Col
                    xs={12}
                    as={Card.Title}
                    className="d-md-none my-auto text-center mb-3"
                >
                    <h2>Have a property to sell?</h2>
                </Col>
                <Col
                    xs={7}
                    as={Card.Title}
                    className="d-none d-md-flex my-auto"
                >
                    <h2>Have a property to sell?</h2>
                </Col>
                <Col
                    xs={12}
                    md={5}
                    as={Card.Text}
                    className="align-self-center"
                >
                    <Col
                        xs={12}
                        as={Button}
                        size="lg"
                        variant="warning"
                        className="m-0 px-3 rounded-0"
                        onClick={() => {
                            dispatch(toggleValuationModal(true))
                        }}
                    >
                        <span className="m-0 text-white">
                            Get a free valuation
                        </span>
                    </Col>
                </Col>
            </Row>
        </Col>
        // Home To Sell Card End
    )
}

export default HomeToSell
